import { Injectable } from '@angular/core';
import { ITaskV2AssignedUser } from '@fi-app/task-v2/fi-task-v2';
import { AppTextService } from '@fi-shared/app-text';
import { FiTaskV2ViewAssigneesDialogComponent } from './fi-task-v2-view-assignees-dialog/fi-task-v2-view-assignees-dialog.component';
import { TaskV2AddAssigneesDialogComponent } from './fi-task-v2-add-assignees-dialog/fi-task-v2-add-assignees-dialog.component';
import { IFiDialogResult } from '@fi-shared/fi-dialogs/fi-dialogs';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { ILightWeightObject } from '@fi-shared/models';

@Injectable()
export class FiTaskV2AssigneeHelperService {
    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
    ) {}

    getCardHeaderText(isRoleUnitAssignee: boolean): string {
        return isRoleUnitAssignee
            ? this.appTextService.get('taskv2.assigned_roles_locations')
            : this.appTextService.get('taskv2.assigned_staff_members');
    }

    openAddStaffMembersAssigneeDialog(
        assignedUsers: ITaskV2AssignedUser[],
        availableUsersForAssignee: ITaskV2AssignedUser[],
    ): IFiDialogResult<number[]> {
        return this.fiDialogsService.custom({
            contentComponentRef: TaskV2AddAssigneesDialogComponent,
            contentComponentData: {
                assignedUsers: assignedUsers || [],
                availableUsersForAssignee: availableUsersForAssignee,
            },
            isHeaderCloseButtonShown: true,
            isHeaderDividerShown: true,
            headerText: this.appTextService.get('common.add_staff_members'),
            headerDividerClass: 'BrandedBorderColor',
            yesButtonText: this.appTextService.get('common.save'),
            noButtonText: this.appTextService.get('common.cancel'),
            preventUppercaseButtonLabel: true,
            hideDialogTopBorder: true,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
                maxWidth: '435px',
                minWidth: '435px',
                autoFocus: false,
                disableClose: true,
            },
        });
    }

    openViewStaffMembersAssigneeDialog(
        assignedUsers: ITaskV2AssignedUser[],
        taskRoles: ILightWeightObject[],
        taskUnits: ILightWeightObject[],
    ): void {
        this.fiDialogsService.custom({
            contentComponentRef: FiTaskV2ViewAssigneesDialogComponent,
            contentComponentData: { assignedUsers, taskRoles, taskUnits },
            isHeaderCloseButtonShown: true,
            isHeaderDividerShown: true,
            headerText: this.appTextService.get('taskv2.assigned_staff_members'),
            headerDividerClass: 'BrandedBorderColor',
            hideFooter: true,
            hideDialogTopBorder: true,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
                maxWidth: '435px',
                minWidth: '435px',
                autoFocus: false,
            },
        });
    }
}
